import script from "./GridEditorColumnManager.vue?vue&type=script&setup=true&lang=js"
export * from "./GridEditorColumnManager.vue?vue&type=script&setup=true&lang=js"

import "./GridEditorColumnManager.vue?vue&type=style&index=0&id=7581deef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7581deef"]])

export default __exports__